// docs/score/announcer-ui-redesign.md §3 — the four-band layout frame's
// fixed widths, plus the one breakpoint that changes how band 4 sits.
// NavRail's own width (72px / 200px) is owned by common-fe's
// NavRailContext, not here — AnnouncerFrame.jsx only owns the three bands
// it renders itself: the day, the live desk, and the look-up column.
// #3392: the day band (class list) is 360px so full class names fit; the
// look-up column is 400px; the live desk in the middle gives up the difference
// (it prefers LIVE_DESK_WIDTH but may shrink to LIVE_DESK_MIN_WIDTH, the
// mockup's 1fr centre at a 1280px window with the collapsed rail).
export const DAY_BAND_WIDTH = 360;
export const LIVE_DESK_WIDTH = 560;
export const LIVE_DESK_MIN_WIDTH = 448;
export const LOOKUP_BAND_WIDTH = 400;

// §3.6 — "Below ~1100px the look-up column stops sitting beside the desk
// and slides over it." NavRail, the day, and the desk never collapse at
// any width down to the supported floor (~1024px landscape) — that floor
// message is out of scope for this card, only the >=1100 vs <1100 split
// belongs to the frame itself.
//
// #3392: with the day band at 360px and the look-up column at 400px, the
// inline layout needs DAY + LIVE_DESK_MIN + LOOKUP = 1208px of band-row width
// (a 1280px window with the collapsed 72px rail), so that is where the
// look-up column switches from inline to overlay.
export const LOOKUP_OVERLAY_BREAKPOINT_PX = DAY_BAND_WIDTH + LIVE_DESK_MIN_WIDTH + LOOKUP_BAND_WIDTH;
